import { render } from "./HospitalReg.vue?vue&type=template&id=4bde34d3&scoped=true"
import script from "./HospitalReg.vue?vue&type=script&lang=js"
export * from "./HospitalReg.vue?vue&type=script&lang=js"

import "./HospitalReg.vue?vue&type=style&index=0&id=4bde34d3&lang=css"
import "./HospitalReg.vue?vue&type=style&index=1&id=4bde34d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bde34d3"]])

export default __exports__